import { render } from "./ProjectCard.vue?vue&type=template&id=dcb48788&scoped=true"
import script from "./ProjectCard.vue?vue&type=script&lang=js"
export * from "./ProjectCard.vue?vue&type=script&lang=js"

import "./ProjectCard.vue?vue&type=style&index=0&id=dcb48788&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dcb48788"

export default script